import React from 'react';

export interface IconFacebookProps {
  className?: string;
  size?: number | string;
  color?: string;
  fill?: string;
  stroke?: string;
}

const IconFacebook: React.FC<IconFacebookProps> = ({ 
  className = '', 
  size = 24, 
  color = 'currentColor', 
  fill, 
  stroke 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      fill={fill || 'none'}
    >
       <path d="M17 2H14.2727C13.0672 2 11.911 2.52678 11.0586 3.46447C10.2062 4.40215 9.72727 5.67392 9.72727 7V10H7V14H9.72727V22H13.3636V14H16.0909L17 10H13.3636V7C13.3636 6.73478 13.4594 6.48043 13.6299 6.29289C13.8004 6.10536 14.0316 6 14.2727 6H17V2Z" fill={fill || "#020617"} />  
    </svg>
  );
};

export default IconFacebook;
